/**
 * @generated SignedSource<<9a3faa28203c26739ed52fb587f4d874>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardStudentsRosterQuery$variables = Record<PropertyKey, never>;
export type DashboardStudentsRosterQuery$data = {
  readonly hasUserClassWithActiveStudent: boolean;
};
export type DashboardStudentsRosterQuery = {
  response: DashboardStudentsRosterQuery$data;
  variables: DashboardStudentsRosterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasUserClassWithActiveStudent",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardStudentsRosterQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardStudentsRosterQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0bc311341fd86d9a4009bbfe540ecebe",
    "id": null,
    "metadata": {},
    "name": "DashboardStudentsRosterQuery",
    "operationKind": "query",
    "text": "query DashboardStudentsRosterQuery {\n  hasUserClassWithActiveStudent\n}\n"
  }
};
})();

(node as any).hash = "e7f3711e4a8ace80e951467b04714390";

export default node;
